import { IFrameCardProps } from '../FrameCardTemplate';

export function getCardKey(card: IFrameCardProps): string {
  if ('id' in card && card.id) {
    return `card-${card.id}`;
  }
  if ('title' in card && card.title) {
    return `card-${card.title}`;
  }
  return 'card-loading';
}
